import { useSearchParams } from 'react-router-dom';
import { PaginatedListPageSkeleton } from '../../components/paginated-list/PaginatedListSkeleton';
import { parseSearchParams } from '../../utils/url';
import { FeaturedNoticeSectionSkeleton } from './components/FeaturedNoticeSectionSkeleton';
import { NoticeCardSkeleton } from '../../components/notice-card/NoticeCardSkeleton';

export const NoticeListPageSkeleton: React.FC = () => {
  const [searchParams] = useSearchParams();
  const parsedSearchParams = parseSearchParams(searchParams);
  return (
    <PaginatedListPageSkeleton
      ItemSkeleton={<NoticeCardSkeleton />}
      AfterSearchFilterComponent={
        Object.keys(parsedSearchParams).length > 0 ? undefined : <FeaturedNoticeSectionSkeleton />
      }
    />
  );
};
